module.exports = __webpack_public_path__ + "media/images/common/icon-balloon-ee89fb220ba95aaa009ede6d51ae5265.svg";